/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import Stepper from "../../../components/ui/stepper";
import { ChevronDown, Pencil } from "lucide-react";
import Img_pdf from "../../../assets/images/Img_pdf.png";
import Modal from "../../../components/common/modal";
import { AddComment } from "./addComment";
import { isValid, addDays, differenceInCalendarDays } from "date-fns";

function formatPrice(inputStr: any) {
  let noSuffix = inputStr.replace(" NOK", "");
  let withDots = noSuffix.replace(/\s+/g, " ");
  return "kr " + withDots;
}

export const Fremdriftsplan: React.FC<{
  bankData: any;
  loading: any;
  getData: any;
}> = ({ bankData, getData }) => {
  const [currIndex, setCurrIndex] = useState<number>(0);

  const order = [
    "Byggekontrakt",
    "Grunnarbeider",
    "Betongarbeid",
    "LeveringByggesett",
    "TettBygg",
    "FerdigUte",
    "FerdigInne",
    "Forhåndsbefaring",
    "Overtakelse",
  ];

  // const steps = bankData?.Fremdriftsplan
  //   ? Object.entries(bankData?.Fremdriftsplan)
  //       .filter(([key]) => key !== "id")
  //       .map(([key, value]: any) => ({
  //         name: key,
  //         ...value,
  //       }))
  //       .sort((a, b) => order.indexOf(a.name) - order.indexOf(b.name))
  //   : [];

  const filteredEntries = Object.entries(bankData?.Fremdriftsplan || {}).filter(
    ([key]) => key !== "Indexing" && key !== "Endringsmelding"
  );

  const steps: any = bankData?.Fremdriftsplan?.FremdriftsplanOg
    ? bankData?.Fremdriftsplan?.FremdriftsplanOg
    : bankData?.Fremdriftsplan
    ? filteredEntries
        .filter(([key]) => key !== "id")
        .map(([key, value]: any) => ({
          name: key,
          ...value,
        }))
        .sort((a, b) => {
          if (typeof a.order === "number" && typeof b.order === "number") {
            return a.order - b.order;
          }
          return order.indexOf(a.name) - order.indexOf(b.name);
        })
    : [];

  useEffect(() => {
    if (steps && steps.length > 0) {
      const lastTruthyIndex = steps.reduce(
        (lastIndex: any, item: any, idx: any) => {
          return item.comment ? idx : lastIndex;
        },
        -1
      );

      if (lastTruthyIndex !== -1) {
        setCurrIndex(lastTruthyIndex + 1);
      }
    }
  }, [steps]);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [SelectIndex, setSelectIndex] = useState<any>(null);
  const handleConfirmPopup = () => {
    if (isModalOpen) {
      setIsModalOpen(false);
    } else {
      setIsModalOpen(true);
    }
  };

  const [openStepIndex, setOpenStepIndex] = useState<number | null>(null);
  const toggleAccordion = (index: number) => {
    setOpenStepIndex((prev) => (prev === index ? null : index));
  };

  return (
    <>
      <div className="mb-20 flex flex-col gap-4 md:gap-6">
        <div className="rounded-lg bg-lightGreen w-full">
          <div className="p-3 md:p-4">
            <h3 className="text-base lg:text-lg font-semibold text-black3 mb-2">
              Fremdrifts- og faktureringsplan
            </h3>
            <p className="text-gray4 text-xs md:text-sm">
              Her oppdaterer du status på fremdriften slik at banken får
              oppdatert informasjon om fremdriften.
            </p>
          </div>
          <div className="p-1 pt-0">
            <div className="bg-white p-4 rounded-lg border border-gray3 shadow-shadow4">
              {steps && steps.length > 0 ? (
                <div>
                  <h3 className="text-sm md:text-base text-black3 font-semibold mb-4">
                    Fremdriftsplan
                  </h3>
                  <Stepper steps={steps} currIndex={currIndex} Style="true" />
                </div>
              ) : (
                "Fremdriftsplan ikke funnet!"
              )}
            </div>
          </div>
        </div>
        <div className="flex flex-col gap-4 md:gap-6">
          {steps &&
            steps.map((step: any, index: number) => {
              let diffText: any = "";

              // if (step?.comment?.full_fort_date) {
              //   const baseDate = new Date(step?.startDate ?? step?.date);
              //   const fullFortDate = new Date(step?.comment.full_fort_date);

              //   const expectedDate = addDays(baseDate, Number(step?.day) || 0);

              //   if (isValid(expectedDate) && isValid(fullFortDate)) {
              //     const dayDifference = differenceInCalendarDays(
              //       fullFortDate,
              //       expectedDate
              //     );
              //     diffText = `(${
              //       dayDifference >= 0 ? "+" : ""
              //     }${dayDifference} dager)`;
              //   }
              // }

              const baseDate = new Date(step?.startDate ?? step?.date);
              let expectedDate: Date | null = null;

              if (step.endDate) {
                expectedDate = new Date(step.endDate);
              } else if (step.day !== undefined) {
                expectedDate = addDays(baseDate, Number(step.day) || 0);
              }

              if (expectedDate && step?.comment?.full_fort_date) {
                const fullFortDate = new Date(step.comment.full_fort_date);

                if (isValid(expectedDate) && isValid(fullFortDate)) {
                  const dayDifference = differenceInCalendarDays(
                    fullFortDate,
                    expectedDate
                  );
                  diffText = `(${
                    dayDifference >= 0 ? "+" : ""
                  }${dayDifference} dager)`;
                }
              }

              return (
                // <div
                //   key={index}
                //   className={`py-3 px-4 bg-blackOpacity3 rounded-lg border flex flex-col gap-4 ${
                //     step?.status === "Kunde fått svar"
                //       ? "border-mint2"
                //       : step?.status === "Unpaid" ||
                //         step?.status === "Avsluttet"
                //       ? "border-pink"
                //       : (step?.status === "Sendt" ||
                //           step?.status === "Ikke sendt") &&
                //         "border-lightOrange2"
                //   }`}
                // >
                <div
                  className={`rounded-lg bg-lightGreen w-full border ${
                    step?.status === "Kunde fått svar"
                      ? "border-mint2"
                      : step?.status === "Unpaid" ||
                        step?.status === "Avsluttet"
                      ? "border-pink"
                      : (step?.status === "Sendt" ||
                          step?.status === "Ikke sendt") &&
                        "border-lightOrange2"
                  }
                  `}
                  key={index}
                >
                  <div className="p-3 md:p-4">
                    <div
                      className={`flex flex-col sm:flex-row sm:items-center gap-2 justify-between ${
                        currIndex > index && "cursor-pointer"
                      } `}
                      onClick={() => {
                        if (currIndex > index) toggleAccordion(index);
                      }}
                    >
                      <div className="flex items-center gap-2 md:gap-4 mb-3 md:mb-4">
                        <h4 className="text-black3 font-medium text-sm md:text-base">
                          Step {index + 1}:{" "}
                          <span className="font-semibold">
                            {step?.navn || step?.name}
                          </span>
                        </h4>
                        {currIndex > index && (
                          <div className="flex items-center gap-2 md:gap-4 justify-end">
                            {step?.status === "Kunde fått svar" ? (
                              <div className="bg-lightBlue rounded-[16px] py-0.5 px-1 sm:px-2 text-[10px] sm:text-xs text-primary">
                                Betalt {formatPrice(step?.pris)} (
                                {(step?.startDate ?? step?.date)
                                  .split("-")
                                  .reverse()
                                  .join(".")}
                                )
                              </div>
                            ) : step?.status === "Avsluttet" ? (
                              <div className="bg-lightMarun rounded-[16px] py-0.5 px-1 sm:px-2 text-[10px] sm:text-xs text-marun">
                                Avvis
                              </div>
                            ) : (
                              step?.status === "Sendt" && (
                                <div className="bg-lightOrange rounded-[16px] py-0.5 px-1 sm:px-2 text-[10px] sm:text-xs text-orange2">
                                  Send Information
                                </div>
                              )
                            )}
                          </div>
                        )}
                      </div>
                      {currIndex > index ? (
                        <div className="flex items-center gap-2 md:gap-4 justify-end">
                          <ChevronDown
                            className={`text-primary transition-transform duration-200 ${
                              openStepIndex === index ? "rotate-180" : ""
                            }`}
                          />
                        </div>
                      ) : currIndex === index ? (
                        <div className="flex items-center gap-2 md:gap-4 justify-end">
                          <span
                            className="text-primary text-sm font-semibold cursor-pointer"
                            onClick={() => {
                              setIsModalOpen(true);
                              setSelectIndex(step?.name ? step?.name : index);
                            }}
                          >
                            Fullfør steget
                          </span>
                          <div className="bg-lightMarun rounded-[16px] py-0.5 px-1 sm:px-2 text-[10px] sm:text-xs text-marun">
                            Ubetalt
                          </div>
                        </div>
                      ) : (
                        currIndex < index && (
                          <div className="bg-lightMarun rounded-[16px] py-0.5 px-1 sm:px-2 text-[10px] sm:text-xs text-marun w-max ml-auto">
                            Ubetalt
                          </div>
                        )
                      )}
                    </div>
                    <div
                      className={`grid grid-cols-1 sm:grid-cols-2 ${
                        step?.comment ? "lg:grid-cols-4" : "lg:grid-cols-3"
                      } gap-2 md:gap-3 desktop:gap-4`}
                    >
                      <div className="w-full flex flex-col gap-1">
                        <p className="text-gray4 text-xs md:text-sm">
                          Forventet oppstart
                        </p>
                        <h6 className="text-black3 font-semibold text-xs md:text-sm">
                          {(step?.startDate ?? step?.date)
                            .split("-")
                            .reverse()
                            .join(".")}
                        </h6>
                      </div>
                      {step?.comment && (
                        <div className="w-full flex flex-col gap-1">
                          <p className="text-gray4 text-xs md:text-sm">
                            Fullført
                          </p>
                          <h6 className="text-black3 font-semibold text-xs md:text-sm">
                            {step?.comment?.full_fort_date &&
                              step?.comment?.full_fort_date
                                .split("-")
                                .reverse()
                                .join(".")}{" "}
                            <span className="text-black2">{diffText}</span>
                          </h6>
                        </div>
                      )}
                      <div className="w-full flex flex-col gap-1">
                        <p className="text-gray4 text-xs md:text-sm">
                          Antatt antall dager til å fullføre
                        </p>
                        {/* <h6 className="text-black3 font-semibold text-xs md:text-sm">
                        {step?.day} dager
                      </h6> */}
                        <h6 className="text-black3 font-semibold text-xs md:text-sm">
                          {step?.day
                            ? `${step.day} dager`
                            : (() => {
                                let dayCount = "";
                                const startDate = new Date(
                                  step?.startDate ?? step?.date
                                );
                                const endDate: any =
                                  step?.endDate || step?.comment?.full_fort_date
                                    ? new Date(
                                        step?.endDate ??
                                          step?.comment?.full_fort_date
                                      )
                                    : null;

                                if (isValid(startDate) && isValid(endDate)) {
                                  const diffDays = differenceInCalendarDays(
                                    endDate,
                                    startDate
                                  );
                                  dayCount = `${diffDays} dager`;
                                }
                                return dayCount || "-";
                              })()}
                        </h6>
                      </div>
                      <div className="w-full flex flex-col gap-1">
                        <p className="text-gray4 text-xs md:text-sm">
                          Utbetaling ihht. faktureringsplan
                        </p>
                        <h6 className="text-black3 font-semibold text-xs md:text-sm">
                          {formatPrice(step?.pris)}
                        </h6>
                      </div>
                    </div>
                  </div>
                  {currIndex > index && openStepIndex === index && (
                    <div className="p-1 pt-0">
                      <div className="bg-white p-4 rounded-lg border border-gray3 shadow-shadow4">
                        <>
                          <div className="flex items-center justify-between gap-2 mb-2">
                            <h3 className="text-black3 font-semibold text-sm md:text-base">
                              Kommentar fra utbygger
                            </h3>
                            {step?.status !== "Kunde fått svar" && (
                              <Pencil
                                className="text-primary cursor-pointer w-5 h-5 md:w-6 md:h-6"
                                onClick={() => {
                                  setIsModalOpen(true);
                                  setSelectIndex(
                                    step?.name ? step?.name : index
                                  );
                                }}
                              />
                            )}
                          </div>
                          <p className="text-gray4 text-xs md:text-sm mb-4 md:mb-5">
                            {step?.comment.text}
                          </p>
                          <div>
                            <h4 className="text-black3 font-semibold text-xs md:text-sm">
                              Bilder fra jobben:
                            </h4>
                            {step?.comment.photo && (
                              <div className="mt-3 md:mt-5 overflow-x-auto">
                                <div className="flex items-center gap-3 md:gap-5 w-max">
                                  {step?.comment.photo?.map(
                                    (file: string, index: number) => {
                                      const isPdf = file
                                        .toLowerCase()
                                        .includes(".pdf");
                                      return (
                                        <div
                                          className="relative h-[130px] md:h-[140px] w-[130px] md:w-[140px] flex-shrink-0"
                                          key={index}
                                        >
                                          <img
                                            src={isPdf ? Img_pdf : file}
                                            alt={
                                              isPdf
                                                ? "PDF file"
                                                : "Uploaded image"
                                            }
                                            className="object-cover w-full h-full rounded-lg"
                                          />
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              </div>
                            )}
                          </div>
                          {currIndex > index &&
                            openStepIndex === index &&
                            step?.payment && (
                              <div>
                                <div className="flex items-center justify-between gap-2 mb-2">
                                  <h3 className="text-black3 font-semibold text-sm md:text-base">
                                    Grunnarbeider: Svar til utbygger
                                  </h3>
                                </div>
                                <p className="text-grey text-sm md:text-base mb-4 md:mb-5">
                                  {step?.payment.text}
                                </p>
                                <div>
                                  <h4 className="text-black3 font-semibold text-xs md:text-sm">
                                    Dokumenter
                                  </h4>
                                  {step?.payment.pdf && (
                                    <div className="mt-3 md:mt-5 overflow-x-auto">
                                      <div className="flex items-center gap-3 md:gap-5 w-max">
                                        {step?.payment.pdf?.map(
                                          (_file: any, index: number) => (
                                            <div
                                              className="relative h-[130px] md:h-[140px] w-[130px] md:w-[140px]"
                                              key={index}
                                            >
                                              <img
                                                src={Img_pdf}
                                                alt="logo"
                                                className="object-cover w-full h-full rounded-lg"
                                              />
                                            </div>
                                          )
                                        )}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            )}
                        </>
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
        </div>
      </div>

      {isModalOpen && (
        <Modal onClose={handleConfirmPopup} isOpen={true}>
          <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-50 mx-4">
            <div className="bg-white rounded-lg shadow-lg overflow-hidden w-full md:w-[80%] max-h-[80vh] overflow-y-auto">
              <AddComment
                SelectIndex={SelectIndex}
                setIsModalOpen={setIsModalOpen}
                getData={getData}
              />
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};
